export const environment = {
  production: true,
  apiUrl: 'https://globalassethub-dev.sonypictures.com/gahapi',
  baseUrl: 'https://globalassethub-dev.sonypictures.com',
  stripoPluginStaticSource: 'https://plugins.stripo.email/static/latest/stripo.js',
  stripoPluginAuth : 'https://plugins.stripo.email/api/v1/auth',
  okta: {
    issuer: 'https://spe.oktapreview.com',
    clientId: '0oa22hvnxgr0kv9Ti0h8',
    redirectUri: 'https://globalassethub-dev.sonypictures.com/login/callback',
    scopes: ['openid', 'profile', 'email'],
    postLogoutRedirectUri:'https://globalassethub-dev.sonypictures.com'
  }
};
